module.exports = __webpack_public_path__ + "img/HZ-T1340.0a3a839f.jpg";